<template>
    <CContainer fluid class="p-0" v-show="!storePageLoading">
        <CRow>
            <CCol xl="12" md="12">
                <div id="gjs"></div>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>
import { mapGetters } from "vuex";
import store from "~/store";

import axios from "axios";
import GrapesJs from "grapesjs";
import pluginBootstrap4 from "grapesjs-blocks-bootstrap4";
import pluginLorySlider from "grapesjs-lory-slider";
import pluginTabs from "grapesjs-tabs";
import pluginCustomCode from "grapesjs-custom-code";
import pluginTouch from "grapesjs-touch";
import pluginParserPostCss from "grapesjs-parser-postcss";
import pluginTuiImageEditor from "grapesjs-tui-image-editor";
import pluginTyped from "grapesjs-typed";
import pluginStyleLg from "grapesjs-style-bg";
import pluginTooltip from "grapesjs-tooltip";
import pluginForms from "grapesjs-plugin-forms";
import pluginPresetWebpage from "grapesjs-preset-webpage";
import pluginCKEDITOR from "grapesjs-plugin-ckeditor";
import pluginLeadgrease from "~/plugins/grapesjs";

import pageMixin from "~/mixins/page.js";
import { template } from "@babel/core";

export default {
    name: "StepBuilderPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin],

    layout: "builder",

    data() {
        return {
            editor: null,
            assetManager: {
                storageType: "",
                multiUpload: false,
                autoAdd: 1,
                uploadName: "file",
                storeOnChange: true,
                storeAfterUpload: true,
                headers: {
                    Authorization: `Bearer ${store.getters["auth/token"]}`,
                },
                upload: `${axios.defaults.baseURL}/upload/resource?type=img_landing`,
                assets: [],
            },
        };
    },
    computed: {
        step_id: function () {
            return this.$route.params.stepId;
        },
        template_id: function () {
            return this.$route.params.templateId;
        },
        ...mapGetters({
            user: "auth/user",
        }),
        baseURL: function () {
            let baseURL = axios.defaults.baseURL;
            if (
                this.user &&
                this.user["custom:tenant_id"] &&
                process.env.VUE_APP_API_MODE === "prod"
                && baseURL !== process.env.VUE_APP_API_AUTH
            ) {
                baseURL = baseURL + "/" + this.user["custom:tenant_id"];
            }
            return baseURL;
        },
    },
    watch: {
        step_id(newValue, oldValue) {
            this.editor.destroy();
            this.initGrapesJsEditor();
        },
    },
    methods: {
        initGrapesJsEditor() {
            this.editor = GrapesJs.init({
                container: "#gjs",
                allowScripts: 1,
                avoidInlineStyle: 1,
                protectedCss: "",
                height: "100vh",
                fromElement: 1,
                showOffsets: 1,
                assetManager: {
                    storageType: "",
                    multiUpload: false,
                    autoAdd: 1,
                    uploadName: "file",
                    storeOnChange: true,
                    storeAfterUpload: true,
                    headers: {
                        Authorization: `Bearer ${store.getters["auth/token"]}`,
                    },
                    upload: `${this.baseURL}/upload/resource?type=img_landing`,
                    assets: [],
                    uploadFile: this.uploadFile,
                },
                selectorManager: { componentFirst: true },
                styleManager: { clearProperties: 1 },
                /* commands: {
                    defaults: [
                        window['@truenorthtechnology/grapesjs-code-editor'].codeCommandFactory()
                    ]
                }, */
                storageManager: {
                    id: "gjs_",
                    contentTypeJson: true,
                    type: "S-STEPS",
                    headers: {
                        Authorization: `Bearer ${store.getters["auth/access_token"]}`,
                    },
                    urlStore: `${this.baseURL}/templates.api/${this.template_id}/steps/${this.step_id}/update`,
                    urlLoad: `${this.baseURL}/templates.api/${this.template_id}/steps/${this.step_id}`,
                    template_uid: this.template_id,
                    fetchOptions: function (opts) {
                        if (opts.method === "post") {
                            opts.method = "put";
                        }
                    },
                    autosave: true,
                },
                canvas: {
                    styles: [
                        "https://use.fontawesome.com/releases/v5.15.1/css/all.css",
                        "https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css",
                    ],
                    scripts: [
                        "https://code.jquery.com/jquery-3.3.1.slim.min.js",
                        "https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.3/umd/popper.min.js",
                        "https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/js/bootstrap.min.js",
                        "https://unpkg.com/@popperjs/core@2/dist/umd/popper.min.js",
                        "https://unpkg.com/tippy.js@6/dist/tippy-bundle.umd.js",
                    ],
                },
                plugins: [
                    //  'grapesjs-components-farmer',
                    pluginCKEDITOR,
                    pluginBootstrap4,
                    pluginLorySlider,
                    pluginTabs,
                    pluginCustomCode,
                    pluginTouch,
                    pluginParserPostCss,
                    pluginTooltip,
                    pluginTuiImageEditor,
                    pluginTyped,
                    pluginStyleLg,
                    pluginForms,
                    pluginPresetWebpage,
                    // pluginLeadgrease, // Custom plugin
                    // pluginSlimEditorCode // Custom plugin
                    pluginLeadgrease,
                ],
                pluginsOpts: {
                    [pluginLeadgrease]: {
                        step_id: this.step_id,
                        template_id: this.template_id,
                        header: {
                            "Content-Type": "application/json",
                            "Access-Control-Allow-Origin": "*",
                            Authorization: `Bearer ${store.getters["auth/access_token"]}`,
                        },
                        host_api: this.baseURL,
                        questions_by_step: [],
                        components: {
                            gender: {
                                name: "gender",
                                man: {
                                    value: "H",
                                    label: "Sr",
                                },
                                woman: {
                                    value: "W",
                                    label: "Sra",
                                },
                            },
                        },
                        resources: [
                            {
                                type: "font",
                                active: true,
                                name: "Roboto",
                                value: "Roboto, Arial, sans-serif",
                                external_resource: false,
                                position: "head",
                                url: "",
                            },
                        ],
                    },
                    [pluginCKEDITOR]: {
                        position: "center",
                        options: {
                            startupFocus: true,
                            extraAllowedContent: "*(*);*{*}", // Allows any class and any inline style
                            allowedContent: true, // Disable auto-formatting, class removing, etc.
                            enterMode: CKEDITOR.ENTER_BR,
                            extraPlugins:
                                "sharedspace,justify,colorbutton,panelbutton,font",
                            toolbar: [
                                {
                                    name: "document",
                                    groups: ["mode", "document", "doctools"],
                                },
                                {
                                    name: "clipboard",
                                    items: [
                                        "Cut",
                                        "Copy",
                                        "Paste",
                                        "PasteText",
                                        "-",
                                        "Undo",
                                        "Redo",
                                    ],
                                },
                                { name: "styles", items: ["Font", "FontSize"] },
                                ["Bold", "Italic", "Underline", "Strike"],
                                {
                                    name: "paragraph",
                                    items: ["NumberedList", "BulletedList"],
                                },
                                { name: "links", items: ["Link", "Unlink"] },
                                {
                                    name: "colors",
                                    items: ["TextColor", "BGColor"],
                                },
                            ],
                        },
                    },
                    [pluginLorySlider]: {
                        sliderBlock: {
                            category: "Extra",
                        },
                    },
                    [pluginTabs]: {
                        tabsBlock: {
                            category: "Extra",
                        },
                    },
                    [pluginTyped]: {
                        block: {
                            category: "Extra",
                            content: {
                                type: "typed",
                                "type-speed": 40,
                                strings: [
                                    "Text row one",
                                    "Text row two",
                                    "Text row three",
                                ],
                            },
                        },
                    },
                    [pluginForms]: {
                        /* ...options */
                    },
                    [pluginPresetWebpage]: {
                        modalImportTitle: "Import Template",
                        modalImportLabel:
                            '<div style="margin-bottom: 10px; font-size: 13px;">Paste here your HTML/CSS and click Import</div>',
                        modalImportContent: function (editor) {
                            return (
                                editor.getHtml() +
                                "<style>" +
                                editor.getCss() +
                                "</style>"
                            );
                        },
                        filestackOpts: null, //{ key: 'AYmqZc2e8RLGLE7TGkX3Hz' },
                        aviaryOpts: false,
                        blocks: ["quote", "text-basic"],
                        blocksBasicOpts: false, //{ flexGrid: 1 },
                        customStyleManager: [
                            {
                                name: "General",
                                buildProps: [
                                    "float",
                                    "display",
                                    "position",
                                    "top",
                                    "right",
                                    "left",
                                    "bottom",
                                ],
                                properties: [
                                    {
                                        name: "Alignment",
                                        property: "float",
                                        type: "radio",
                                        defaults: "none",
                                        list: [
                                            {
                                                value: "none",
                                                className: "fa fa-times",
                                            },
                                            {
                                                value: "left",
                                                className: "fa fa-align-left",
                                            },
                                            {
                                                value: "right",
                                                className: "fa fa-align-right",
                                            },
                                        ],
                                    },
                                    { property: "position", type: "select" },
                                ],
                            },
                            {
                                name: "Dimension",
                                open: false,
                                buildProps: [
                                    "width",
                                    "flex-width",
                                    "height",
                                    "max-width",
                                    "min-height",
                                    "margin",
                                    "padding",
                                ],
                                properties: [
                                    {
                                        id: "flex-width",
                                        type: "integer",
                                        name: "Width",
                                        units: ["px", "%"],
                                        property: "flex-basis",
                                        toRequire: 1,
                                    },
                                    {
                                        property: "margin",
                                        properties: [
                                            {
                                                name: "Top",
                                                property: "margin-top",
                                            },
                                            {
                                                name: "Right",
                                                property: "margin-right",
                                            },
                                            {
                                                name: "Bottom",
                                                property: "margin-bottom",
                                            },
                                            {
                                                name: "Left",
                                                property: "margin-left",
                                            },
                                        ],
                                    },
                                    {
                                        property: "padding",
                                        properties: [
                                            {
                                                name: "Top",
                                                property: "padding-top",
                                            },
                                            {
                                                name: "Right",
                                                property: "padding-right",
                                            },
                                            {
                                                name: "Bottom",
                                                property: "padding-bottom",
                                            },
                                            {
                                                name: "Left",
                                                property: "padding-left",
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                name: "Typography",
                                open: false,
                                buildProps: [
                                    "font-family",
                                    "font-size",
                                    "font-weight",
                                    "letter-spacing",
                                    "color",
                                    "line-height",
                                    "text-align",
                                    "text-decoration",
                                    "text-shadow",
                                ],
                                properties: [
                                    { name: "Font", property: "font-family" },
                                    { name: "Weight", property: "font-weight" },
                                    { name: "Font color", property: "color" },
                                    {
                                        property: "text-align",
                                        type: "radio",
                                        defaults: "left",
                                        list: [
                                            {
                                                value: "left",
                                                name: "Left",
                                                className: "fa fa-align-left",
                                            },
                                            {
                                                value: "center",
                                                name: "Center",
                                                className: "fa fa-align-center",
                                            },
                                            {
                                                value: "right",
                                                name: "Right",
                                                className: "fa fa-align-right",
                                            },
                                            {
                                                value: "justify",
                                                name: "Justify",
                                                className:
                                                    "fa fa-align-justify",
                                            },
                                        ],
                                    },
                                    {
                                        property: "text-decoration",
                                        type: "radio",
                                        defaults: "none",
                                        list: [
                                            {
                                                value: "none",
                                                name: "None",
                                                className: "fa fa-times",
                                            },
                                            {
                                                value: "underline",
                                                name: "underline",
                                                className: "fa fa-underline",
                                            },
                                            {
                                                value: "line-through",
                                                name: "Line-through",
                                                className:
                                                    "fa fa-strikethrough",
                                            },
                                        ],
                                    },
                                    {
                                        property: "text-shadow",
                                        properties: [
                                            {
                                                name: "X position",
                                                property: "text-shadow-h",
                                            },
                                            {
                                                name: "Y position",
                                                property: "text-shadow-v",
                                            },
                                            {
                                                name: "Blur",
                                                property: "text-shadow-blur",
                                            },
                                            {
                                                name: "Color",
                                                property: "text-shadow-color",
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                name: "Decorations",
                                open: false,
                                buildProps: [
                                    "opacity",
                                    "border-radius",
                                    "border",
                                    "box-shadow",
                                    "background-bg",
                                ],
                                properties: [
                                    {
                                        type: "slider",
                                        property: "opacity",
                                        defaults: 1,
                                        step: 0.01,
                                        max: 1,
                                        min: 0,
                                    },
                                    {
                                        property: "border-radius",
                                        properties: [
                                            {
                                                name: "Top",
                                                property:
                                                    "border-top-left-radius",
                                            },
                                            {
                                                name: "Right",
                                                property:
                                                    "border-top-right-radius",
                                            },
                                            {
                                                name: "Bottom",
                                                property:
                                                    "border-bottom-left-radius",
                                            },
                                            {
                                                name: "Left",
                                                property:
                                                    "border-bottom-right-radius",
                                            },
                                        ],
                                    },
                                    {
                                        property: "box-shadow",
                                        properties: [
                                            {
                                                name: "X position",
                                                property: "box-shadow-h",
                                            },
                                            {
                                                name: "Y position",
                                                property: "box-shadow-v",
                                            },
                                            {
                                                name: "Blur",
                                                property: "box-shadow-blur",
                                            },
                                            {
                                                name: "Spread",
                                                property: "box-shadow-spread",
                                            },
                                            {
                                                name: "Color",
                                                property: "box-shadow-color",
                                            },
                                            {
                                                name: "Shadow type",
                                                property: "box-shadow-type",
                                            },
                                        ],
                                    },
                                    {
                                        id: "background-bg",
                                        property: "background",
                                        type: "bg",
                                    },
                                ],
                            },
                            {
                                name: "Extra",
                                open: false,
                                buildProps: [
                                    "transition",
                                    "perspective",
                                    "transform",
                                ],
                                properties: [
                                    {
                                        property: "transition",
                                        properties: [
                                            {
                                                name: "Property",
                                                property: "transition-property",
                                            },
                                            {
                                                name: "Duration",
                                                property: "transition-duration",
                                            },
                                            {
                                                name: "Easing",
                                                property:
                                                    "transition-timing-function",
                                            },
                                        ],
                                    },
                                    {
                                        property: "transform",
                                        properties: [
                                            {
                                                name: "Rotate X",
                                                property: "transform-rotate-x",
                                            },
                                            {
                                                name: "Rotate Y",
                                                property: "transform-rotate-y",
                                            },
                                            {
                                                name: "Rotate Z",
                                                property: "transform-rotate-z",
                                            },
                                            {
                                                name: "Scale X",
                                                property: "transform-scale-x",
                                            },
                                            {
                                                name: "Scale Y",
                                                property: "transform-scale-y",
                                            },
                                            {
                                                name: "Scale Z",
                                                property: "transform-scale-z",
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                name: "Flex",
                                open: false,
                                properties: [
                                    {
                                        name: "Flex Container",
                                        property: "display",
                                        type: "select",
                                        defaults: "block",
                                        list: [
                                            { value: "block", name: "Disable" },
                                            { value: "flex", name: "Enable" },
                                        ],
                                    },
                                    {
                                        name: "Flex Parent",
                                        property: "label-parent-flex",
                                        type: "integer",
                                    },
                                    {
                                        name: "Direction",
                                        property: "flex-direction",
                                        type: "radio",
                                        defaults: "row",
                                        list: [
                                            {
                                                value: "row",
                                                name: "Row",
                                                className:
                                                    "icons-flex icon-dir-row",
                                                title: "Row",
                                            },
                                            {
                                                value: "row-reverse",
                                                name: "Row reverse",
                                                className:
                                                    "icons-flex icon-dir-row-rev",
                                                title: "Row reverse",
                                            },
                                            {
                                                value: "column",
                                                name: "Column",
                                                title: "Column",
                                                className:
                                                    "icons-flex icon-dir-col",
                                            },
                                            {
                                                value: "column-reverse",
                                                name: "Column reverse",
                                                title: "Column reverse",
                                                className:
                                                    "icons-flex icon-dir-col-rev",
                                            },
                                        ],
                                    },
                                    {
                                        name: "Justify",
                                        property: "justify-content",
                                        type: "radio",
                                        defaults: "flex-start",
                                        list: [
                                            {
                                                value: "flex-start",
                                                className:
                                                    "icons-flex icon-just-start",
                                                title: "Start",
                                            },
                                            {
                                                value: "flex-end",
                                                title: "End",
                                                className:
                                                    "icons-flex icon-just-end",
                                            },
                                            {
                                                value: "space-between",
                                                title: "Space between",
                                                className:
                                                    "icons-flex icon-just-sp-bet",
                                            },
                                            {
                                                value: "space-around",
                                                title: "Space around",
                                                className:
                                                    "icons-flex icon-just-sp-ar",
                                            },
                                            {
                                                value: "center",
                                                title: "Center",
                                                className:
                                                    "icons-flex icon-just-sp-cent",
                                            },
                                        ],
                                    },
                                    {
                                        name: "Align",
                                        property: "align-items",
                                        type: "radio",
                                        defaults: "center",
                                        list: [
                                            {
                                                value: "flex-start",
                                                title: "Start",
                                                className:
                                                    "icons-flex icon-al-start",
                                            },
                                            {
                                                value: "flex-end",
                                                title: "End",
                                                className:
                                                    "icons-flex icon-al-end",
                                            },
                                            {
                                                value: "stretch",
                                                title: "Stretch",
                                                className:
                                                    "icons-flex icon-al-str",
                                            },
                                            {
                                                value: "center",
                                                title: "Center",
                                                className:
                                                    "icons-flex icon-al-center",
                                            },
                                        ],
                                    },
                                    {
                                        name: "Flex Children",
                                        property: "label-parent-flex",
                                        type: "integer",
                                    },
                                    {
                                        name: "Order",
                                        property: "order",
                                        type: "integer",
                                        defaults: 0,
                                        min: 0,
                                    },
                                    {
                                        name: "Flex",
                                        property: "flex",
                                        type: "composite",
                                        properties: [
                                            {
                                                name: "Grow",
                                                property: "flex-grow",
                                                type: "integer",
                                                defaults: 0,
                                                min: 0,
                                            },
                                            {
                                                name: "Shrink",
                                                property: "flex-shrink",
                                                type: "integer",
                                                defaults: 0,
                                                min: 0,
                                            },
                                            {
                                                name: "Basis",
                                                property: "flex-basis",
                                                type: "integer",
                                                units: ["px", "%", ""],
                                                unit: "",
                                                defaults: "auto",
                                            },
                                        ],
                                    },
                                    {
                                        name: "Align",
                                        property: "align-self",
                                        type: "radio",
                                        defaults: "auto",
                                        list: [
                                            {
                                                value: "auto",
                                                name: "Auto",
                                            },
                                            {
                                                value: "flex-start",
                                                title: "Start",
                                                className:
                                                    "icons-flex icon-al-start",
                                            },
                                            {
                                                value: "flex-end",
                                                title: "End",
                                                className:
                                                    "icons-flex icon-al-end",
                                            },
                                            {
                                                value: "stretch",
                                                title: "Stretch",
                                                className:
                                                    "icons-flex icon-al-str",
                                            },
                                            {
                                                value: "center",
                                                title: "Center",
                                                className:
                                                    "icons-flex icon-al-center",
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },

                    "grapesjs-components-farmer": {
                        formNextId: 1,
                        panel: 1,
                    },
                },
            });

            this.editor.on("asset:upload:response", (response) => {
                this.editor.AssetManager.add(response.url);
            });

            this.updatePageLoading(false);
        },
        uploadFile(e) {
            let files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
            let formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                let newFile = new File([file], `${Date.now()} - ${file.name}`, {
                    type: "image/png",
                });
                formData.append("file", newFile); //containing all the selected images from local
            }

            fetch(`${this.baseURL}/upload/resource?type=img_landing`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${store.getters["auth/token"]}`,
                },
                dataType: "json",
                mimeType: "multipart/form-data",
                mode: "cors",
                credentials: "include",
                body: formData,
            })
                .then((response) => {
                    response.json().then((dataMain) => {
                        console.log(dataMain);
                        this.editor.AssetManager.add(dataMain.url);
                    });
                })
                .catch(function (error) {});
        },
    },

    mounted() {
        this.initGrapesJsEditor();
    },
};
</script>

<style lang="scss">
@import "~grapesjs/dist/css/grapes.min.css";
.gjs-pn-btn svg {
    fill: white;
    width: 21px;
    height: 21px;
}

.gjs-one-bg {
    background-color: #463a3c;
}
.gjs-one-color {
    color: #463a3c;
}
.gjs-one-color-h:hover {
    color: #463a3c;
}
.gjs-two-bg {
    background-color: #b9a5a6;
}
.gjs-two-color {
    color: #b9a5a6;
}
.gjs-two-color-h:hover {
    color: #b9a5a6;
}
.gjs-three-bg {
    background-color: #804f7b;
}
.gjs-three-color {
    color: #804f7b;
}
.gjs-three-color-h:hover {
    color: #804f7b;
}
.gjs-four-bg {
    background-color: #d97aa6;
}
.gjs-four-color {
    color: #d97aa6;
}
.gjs-four-color-h:hover {
    color: #d97aa6;
}
.gjs-pn-btn svg path,
.gjs-pn-btn svg g {
    fill: #b9a5a6;
}
.gjs-block .gjs-block__media svg {
    width: 54px;
    height: auto;
}
</style>